import React from 'react'

export const Galeria = () => {
  return (
    <div>Galeria</div>
  )
}
